<template>
  <div class="app-page-reel" :class="pos">
    <div class="left-o"></div>
    <div class="left-pole"></div>
    <div class="left-reel"></div>
    <div class="reel-i">
      <div class="reel-i-bg"></div>
    </div>
    <div class="right-reel"></div>
    <div class="right-pole"></div>
    <div class="right-o"></div>
  </div>
</template>

<script>
export default {
  props: {
    pos: {
      type: String,
      default: 'top',
    }
  }
}
</script>

<style lang="less" scoped>
.app-page-reel {
  width: 100%;
  height: 60px;
  display: flex;
  align-items: center;
  &.top {
    background: linear-gradient(to bottom, transparent 50%, rgba(0, 0, 0, .3), transparent);
  }
  &.bottom {
    background: linear-gradient(to top, transparent 50%, rgba(0, 0, 0, .3), transparent);
  }
  // 杆两端
  .left-o,.right-o {
    flex-shrink: 0;
    height: 100%;
    aspect-ratio: 80 / 330;
    background-size: 100%;
  }
  .left-o {
    background: url('@/assets/image/reel/left.png');
    background-size: 100% 100%;
  }
  .right-o {
    background: url('@/assets/image/reel/right.png');
    background-size: 100% 100%;
  }
  // 卷两端
  .left-reel,.right-reel {
    flex-shrink: 0;
    height: 100%;
    aspect-ratio: 36 / 330;
    background-size: 100%;
  }
  .left-reel {
    background: url('@/assets/image/reel/reel-l-l.png');
    background-size: 100% 100%;
  }
  .right-reel {
    background: url('@/assets/image/reel/reel-r-l.png');
    background-size: 100% 100%;
  }
  // 杆填充
  .left-pole,.right-pole {
    background: url('@/assets/image/reel/reel-pole.png');
    height: 100%;
    background-repeat: repeat-y;
    flex: 1;
    background-size: 100% 100%;
  }
  // 卷填充
  .reel-i {
    height: 100%;
    width: @pageContentWidth;
    background: url('@/assets/image/reel/reel-pole-i.png');
    background-repeat: repeat-y;
    background-size: 100% 100%;
    .reel-i-bg {
      width: 100%;
      height: 100%;
      background: url('@/assets/image/reel/bg-mas.png');
      background-repeat: repeat;
    }
  }
}
@media screen and (max-width: @pageContentWidth) {
  .app-page-reel {
    // 杆填充
    .left-pole,.right-pole {
      flex: 0;
    }
    // 卷填充
    .reel-i {
      flex: 1;
    }
  }
}
</style>
